@if(initialized && userDocuments) {



<!--  @for(userDocument of userDocuments; track userDocument.id) {-->

<!--    <div>-->
<!--      {{userDocument.id}}-->
<!--      {{userDocument.name}}-->
<!--      {{userDocument.mimeType}}-->

<!--      <p-button label="download document" (click)="handleDownload(userDocument.id)"></p-button>-->

<!--    </div>-->

<!--  }-->

  <ul class="list-none p-0 m-0   border-300">

    <li class="flex align-items-center py-3 px-2 flex-wrap surface-ground">
      <div class="text-900 w-full">
        <div class="grid mt-0 mr-0">
          @for (document of userDocuments; track document.id) {
            <div class="col-12 xl:col-4 lg:col-6">
              <div class="p-3 border-1 surface-border border-round surface-card cursor-pointer" (click)="handleDownload(document.id)">
                <div class="text-color mb-3 flex justify-content-between">
                        <span>
                          <i class="pi mr-2 pt-1"
                             [ngClass]="document.mimeType == 'application/pdf' ? 'pi-file-pdf' : 'pi-image'"></i>
                        <span class="font-medium">{{ document.name }}</span>
                        </span>
                  <i [pTooltip]="'View'" tooltipPosition="top" class="pi pi-eye cursor-pointer"></i>
                </div>
                <div class="flex flex-column gap-3">
                  <div class="text-700">{{ document.additionalInformation }}</div>
                  <div class="flex flex-wrap justify-content-between gap-2">
                    <div class="text-500 text-light">{{ document.mimeType | mimeTypePipe }}</div>
                    <div class="text-500 text-light">{{ document.uploadedOn | date:"dd.MM.YYYY" }}</div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </li>

  </ul>

  <p-dialog
    header="Dokument"
    *ngIf="showDocumentVisible"
    [(visible)]="showDocumentVisible"
    [style]="{width: '65rem', height: '75vh'}"
    [modal]="true"
    (onHide)="showDocumentId = undefined"
  >
    @if (showDocumentId) {
      <app-pdf-view [objectService]="userDocumentApiService"
                    [documentId]="showDocumentId"
                    (handleNewWindowOpened)="handleWindowOpened($event)"
                    class="w-full h-full">
      </app-pdf-view>
    }

  </p-dialog>

  <!--
  <div class="">
    <cross-documents [documents]="signatureDto?.documents" (signaturesChange)="handleSignatureChanges($event)"></cross-documents>

    <div class="flex justify-content-end col-12 py-4">

      <div>

        <app-button [busy]="busy"
                    [disabled]="!signaturesComplete"
                    [label]="'Speichern'"
                    [showIcon]="false"
                    (onClick)="updateSignatures()">
        </app-button>

      </div>
    </div>

  </div>
  -->

}
